import { render, staticRenderFns } from "./Screening.vue?vue&type=template&id=791181a6"
import script from "./Screening.vue?vue&type=script&lang=js"
export * from "./Screening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports